/**
 * Shell — assemble topbar + rail + workspace container + panneau droit.
 */
import { h } from "../components/dom.js";
import { Estimator } from "../services/estimator.js";
import { statusPoller } from "../services/poller.js";
import { store } from "../state/store.js";
import { RailNav } from "./RailNav.js";
import { RightPanel } from "./RightPanel.js";
import { TopBar } from "./TopBar.js";
import type { WorkspaceDef } from "./types.js";

export class Shell {
	readonly element: HTMLElement;
	private readonly topBar: TopBar;
	private readonly rightPanel: RightPanel;
	private readonly rail: RailNav;

	constructor(workspaces: WorkspaceDef[]) {
		this.topBar = new TopBar();
		this.rightPanel = new RightPanel();
		const workspaceContainer = h("div", { class: "workspace-container" });
		this.rail = new RailNav(workspaces, workspaceContainer, { store, estimator: new Estimator() });

		this.element = h(
			"div",
			{ class: "app-shell" },
			this.topBar.element,
			h(
				"div",
				{ class: "app-main" },
				this.rail.element,
				workspaceContainer,
				this.rightPanel.element
			)
		);
	}

	/** Zone utilisateur de la topbar (pilotée par le workspace Compte). */
	get userElement(): HTMLElement {
		return this.topBar.userElement;
	}

	get panel(): RightPanel {
		return this.rightPanel;
	}

	start(): void {
		statusPoller.start();
		this.rail.showFirst();
	}
}
